import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  title: string;
}
export function ProgressBar({
  currentStep,
  totalSteps,
  title
}: ProgressBarProps) {
  const progress = currentStep / totalSteps * 100;
  return <div className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100 px-4 py-3 md:px-8" data-id="element-745" data-mp="23n52e5glslm9">
      <div className="max-w-4xl mx-auto" data-id="element-746" data-mp="28n1766x4kh2v">
        <div className="flex items-center justify-between mb-2" data-id="element-747" data-mp="28m98uoc5858w">
          <div data-id="element-748" data-mp="2cnbdxlsqrbis">
            <span className="text-[10px] font-bold text-[#007AFF] uppercase tracking-widest" data-id="element-749" data-mp="2cms1ulprvhco">
              Stap {currentStep} van {totalSteps}
            </span>
            <h2 className="text-sm font-bold text-gray-900 mt-0.5" data-id="element-750" data-mp="2mefpebj7ke8v">{title}</h2>
          </div>
          <span className="text-xs font-semibold text-gray-400 tabular-nums" data-id="element-751" data-mp="2rd95mbpvqjcq">
            {Math.round(progress)}%
          </span>
        </div>
        <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-752" data-mp="2wclq4pta3ec5">
          <motion.div className="h-full bg-[#007AFF] rounded-full" initial={{
          width: 0
        }} animate={{
          width: `${progress}%`
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} data-id="element-753" data-mp="22zyz9blczxvj" />
        </div>
      </div>
    </div>;
}